<div class="my-5">
  <sm-page-header
    [breadcrumb]="breadcrumb"
    title="settings.contractingAuthority.ac.update.title"
    ></sm-page-header>
  <div class="content">
    <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
    <div class="flex justify-end gap-2">
      <p-button [label]="'settings.contractingAuthority.ac.update.update' | translate" (click)="editContractingAuthority()" />
      <p-button [label]="'settings.contractingAuthority.ac.update.cancel' | translate" severity="secondary" (click)="cancel()" />
    </div>
    <p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)" scrollable class="mt-4 bg-transparent">
      <p-tablist>
        <p-tab value="users"> {{ 'settings.contractingAuthority.tabs.users' | translate }}</p-tab>
        <p-tab value="seuils"> {{ 'settings.contractingAuthority.tabs.seuils' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="users">
          <sm-members
            [acId]="contractingAuthorityRepository.getNested('response', 'id')"
            [members]="contractingAuthorityRepository.getNested('response', 'users')"></sm-members>
        </p-tabpanel>
        <p-tabpanel value="seuils">
          <sm-settings-seuils [acId]="contractingAuthorityRepository.getNested('response', 'id')"></sm-settings-seuils>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
